import Header from "../../components/common/Header";
import SideSectionFrame from "../../components/common/SideSectionFrame";
import { Skeleton, Card, CardContent } from "@mui/material";

const ProposalDetailLoadingIndex = () => {
  const rightCard = (
    <Card
      elevation={4}
      sx={{
        justifyContent: "space-between",
        alignItems: "stretch",
        height: "300px",
        mt: "100px",
      }}
    >
      <CardContent>
        <Skeleton
          variant="rectangular"
          sx={{ height: "30px", width: "20%", mt: "10px" }}
        />
        <Skeleton
          variant="rectangular"
          sx={{ height: "20px", width: "100%", mt: "10px" }}
        />
        <Skeleton
          variant="rectangular"
          sx={{ height: "40px", width: "100%", mt: "10px" }}
        />
        <Skeleton
          variant="rectangular"
          sx={{ height: "80px", width: "100%", mt: "10px" }}
        />
      </CardContent>
    </Card>
  );

  return (
    <>
      <Header />
      <SideSectionFrame
        leftSection={
          <>
            <Card
              elevation={4}
              sx={{
                justifyContent: "space-between",
                alignItems: "stretch",
                height: "300px",
                mt: "20px",
              }}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                sx={{ height: 30 }}
              />
              <CardContent>
                <Skeleton
                  variant="text"
                  sx={{ height: "40px", width: "100%", mt: "10px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "0px", width: "500px", mt: "0px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "20px", width: "80%", mt: "8px" }}
                />
                <Skeleton
                  variant="text"
                  sx={{ height: "90px", width: "100%", mt: "8px" }}
                />
                <Skeleton
                  variant="circular"
                  sx={{ height: "50px", width: "50px", mt: "15px" }}
                />
              </CardContent>
            </Card>

            <Card
              elevation={4}
              sx={{
                justifyContent: "space-between",
                alignItems: "stretch",
                height: "200 px",
                mt: "30px",
              }}
            >
              <Skeleton
                variant="text"
                width="20%"
                sx={{ height: "30px", margin: "auto" }}
              />
              <CardContent>
                <Skeleton
                  variant="text"
                  sx={{ height: "60px", width: "100%", mt: "10px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "0px", width: "500px", mt: "0px" }}
                />
                <Skeleton
                  variant="text"
                  sx={{ height: "60px", width: "100%" }}
                />
              </CardContent>
            </Card>

            <Card
              elevation={4}
              sx={{
                justifyContent: "space-between",
                alignItems: "stretch",
                height: "200 px",
                mt: "30px",
              }}
            >
              <CardContent>
                <Skeleton
                  variant="text"
                  width="20%"
                  sx={{ height: "30px", margin: "auto" }}
                />
                <Skeleton
                  variant="text"
                  sx={{ height: "60px", width: "100%", mt: "10px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "0px", width: "500px", mt: "0px" }}
                />
                <Skeleton
                  variant="text"
                  sx={{ height: "80px", width: "100%" }}
                />
              </CardContent>
            </Card>

            <Skeleton
              variant="rectangular"
              sx={{ height: "40px", width: "100%", mt: "30px" }}
            />
            <Skeleton
              variant="rectangular"
              sx={{ height: "40px", width: "100%", mt: "8px" }}
            />
          </>
        }
        rightSection={
          <>
            <Card
              elevation={4}
              sx={{
                justifyContent: "space-between",
                alignItems: "stretch",
                height: "300px",
                mt: "50px",
              }}
            >
              <CardContent>
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "30px", width: "20%", mt: "10px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "0px", width: "500px", mt: "0px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "20px", width: "30%", mt: "10px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "20px", width: "35%", mt: "10px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "20px", width: "40%", mt: "10px" }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{ height: "60px", width: "100%", mt: "10px" }}
                />
              </CardContent>
            </Card>
            {rightCard}
            {rightCard}
          </>
        }
      ></SideSectionFrame>
    </>
  );
};

export default ProposalDetailLoadingIndex;
